// ─────────────────────────────────────────────────────────────
// DENSA V1 — central site configuration.
// Update values here; components read from this file only.
// ─────────────────────────────────────────────────────────────

export const SITE = {
  name: "DENSA",
  tagline: "Dental Excellence & Networked Smart Administration",

  // PLACEHOLDER — replace with the real Google Play URL at launch, e.g.
  // "https://play.google.com/store/apps/details?id=com.densa.app"
  playStoreUrl: "",

  email: "densa.help@gmail.com",
  supportEmail: "support@densa.in",

  // PLACEHOLDERS — paste real URLs when ready (leave "" to keep them inert)
  socials: {
    instagram: "",
    facebook: "",
    linkedin: "",
    youtube: "https://www.youtube.com/@DENSA-APP",
    whatsapp: "", // e.g. "https://wa.me/91XXXXXXXXXX"
  },

  assets: {
    logoPrimary: "/assets/densa-logo-primary.webp", // teal logo — light backgrounds
    logoWhite: "/assets/densa-logo-white.webp", // white logo — dark backgrounds
    appIcon: "/assets/densa-app-icon.png",
    favicon: "/assets/densa-favicon.png",
    hero: "/assets/hero.webp",
  },

  nav: [
    { label: "Home", href: "#home" },
    { label: "Features", href: "#features" },
    { label: "DIVA", href: "#diva" },
    { label: "Gallery", href: "#gallery" },
    { label: "About", href: "#vision" },
    { label: "Contact", href: "#contact" },
  ],
};

export const scrollToId = (hash) => {
  const target = document.querySelector(hash);
  if (!target) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -72, duration: 1.2 });
  } else {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
